import * as Sentry from '@sentry/react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { ProtectedRoute } from '@frontend/components/ProtectedRoute'
import { Login } from '@frontend/pages/Login'
import { Vendors } from '@frontend/pages/Vendors'
import { VendorDetail } from '@frontend/pages/VendorDetail'
import { Risks } from '@frontend/pages/Risks'
import { RiskDetail } from '@frontend/pages/RiskDetail'
import { Reviews } from '@frontend/pages/Reviews'
import { ReviewDetail } from '@frontend/pages/ReviewDetail'
import { Clients } from '@frontend/pages/Clients'
import { UserManagement } from '@frontend/pages/UserManagement'
import { Auditors } from '@frontend/pages/Auditors'
import { AuditorDetail } from '@frontend/pages/AuditorDetail'

// Feeds the matched route pattern to the tracing integration, so a navigation
// to /vendors/<uuid> is reported as /vendors/:id.
const SentryRoutes = Sentry.wrapReactRouterRouting(Routes)

export default function App() {
  return (
    <>
      <Toaster position="bottom-right" />
      <SentryRoutes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/vendors"
          element={
            <ProtectedRoute>
              <Vendors />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendors/:id"
          element={
            <ProtectedRoute>
              <VendorDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/risks"
          element={
            <ProtectedRoute>
              <Risks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/risks/:id"
          element={
            <ProtectedRoute>
              <RiskDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reviews"
          element={
            <ProtectedRoute>
              <Reviews />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reviews/:id"
          element={
            <ProtectedRoute>
              <ReviewDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auditors"
          element={
            <ProtectedRoute>
              <Auditors />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auditors/:id"
          element={
            <ProtectedRoute>
              <AuditorDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute>
              <Clients />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/vendors" replace />} />
        <Route path="*" element={<Navigate to="/vendors" replace />} />
      </SentryRoutes>
    </>
  )
}
